import { render } from "./sunny.vue?vue&type=template&id=7b19b97a&scoped=true"
import script from "./sunny.vue?vue&type=script&lang=js"
export * from "./sunny.vue?vue&type=script&lang=js"

import "./sunny.vue?vue&type=style&index=0&id=7b19b97a&lang=stylus&scoped=true"

import exportComponent from "D:\\Repository\\Zidan\\pc-customer-admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b19b97a"]])

export default __exports__